<h5 class="text-primary-text">Account Information</h5>
<div class="border-1 border-solid rounded-lg p-16">
  <div class="flex flex-row gap-8 mb-16">
    <b class="text-sm">User email:</b>
    <span>{{ username }}</span>
  </div>

  <div class="flex flex-row gap-8 mb-16">
    <b class="text-sm">Cookie choices:</b>

    <div class="flex items-center gap-4">
      <label class="px-4" nz-checkbox [ngModel]="cookieChoice" (ngModelChange)="changeCookiePreference($event)"> </label>
      <span> Opt-in to third-party cookies </span>
    </div>
  </div>

  <div class="text-sm">There is currently no additional personal information stored in our platform.</div>

  <ng-container *ngIf="showMfaOption">
    <div class="label">Multi-factor authentication:</div>
    <a [routerLink]="['/login/mfa/setup']"> Activate multi-factor authentication </a>
  </ng-container>
</div>
